import { render, staticRenderFns } from "./Avaliacao.vue?vue&type=template&id=2a30a950&scoped=true"
import script from "./Avaliacao.vue?vue&type=script&lang=js"
export * from "./Avaliacao.vue?vue&type=script&lang=js"
import style0 from "./Avaliacao.vue?vue&type=style&index=0&id=2a30a950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30a950",
  null
  
)

export default component.exports